export default __webpack_public_path__ + "static/media/logoHeader1.b3c4adf1.png";